import { getLocale } from "../runtime";

const sv_bgcountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Bulgaria`
};

const bgcountryenglish = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_bgcountryenglish(inputs)
	return "bgCountryEnglish";
};

export { bgcountryenglish as "bgCountryEnglish" };